module.exports = __webpack_public_path__ + "static/img/logo_dev.f27b6bbb.png";